<template>
  <div>
    <vx-card>
      <div>
        <!-- <vs-button @click="getpostpaidlist">click me</vs-button> -->
      </div>
      <vs-row>
        <vs-col>
          <vs-table
            @dblSelection="doubleSelection"
            v-model="selectedUser"
            :data="postpaidinfo"
          >
            <template slot="header">
              <div class="flex mb-3">
                <vs-input
                  label-placeholder="search key"
                  @keyup.enter="searchpostpaiduser()"
                  v-model="search"
                ></vs-input>
                <vs-button
                  class="my-5"
                  @click="searchpostpaiduser()"
                  size="large"
                  icon="search"
                >
                </vs-button>
                <div class="my-4 mx-5">
                  <p class="text-danger">Remove</p>
                  <vs-switch
                    class="my-3"
                    color="danger"
                    vs-icon-off="close"
                    v-model="switch3"
                  >
                    <span slot="on">Enabled</span>
                    <span slot="off">Disabled</span>
                  </vs-switch>
                </div>
              </div>
            </template>
            <template slot="thead">
              <vs-th> ID </vs-th>
              <vs-th> User ID </vs-th>
              <vs-th> نام کاربر </vs-th>
              <vs-th> ایمیل کاربر </vs-th>
              <vs-th> بازه زمانی </vs-th>
              <vs-th> حداکثر اعتبار </vs-th>
              <vs-th> مصرف شده </vs-th>
              <vs-th> توضیحات </vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].id"> {{ data[indextr].id }} </vs-td>
                <vs-td :data="data[indextr].user_id">
                  {{ data[indextr].user_id }}
                </vs-td>
                <vs-td :data="data[indextr].user_fullname">
                  {{ data[indextr].user_fullname }}
                </vs-td>
                <vs-td :data="data[indextr].user_email">
                  {{ data[indextr].user_email }}
                </vs-td>
                <vs-td :data="data[indextr].pay_cycle">
                  {{ data[indextr].pay_cycle }} ماهه</vs-td
                >
                <vs-td :data="data[indextr].maximum_credit">
                  <span class="text-warning">{{
                    data[indextr].maximum_credit
                  }}</span>
                  تومان
                </vs-td>
                <vs-td :data="data[indextr].current_balance">
                  <p
                    :class="
                      data[indextr].current_balance > 0
                        ? 'text-success'
                        : 'text-danger'
                    "
                  >
                    <span>{{ data[indextr].current_balance }}</span>
                  </p>
                  تومان
                </vs-td>
                <vs-td :data="data[indextr].current_balance">
                  {{ data[indextr].description }}
                </vs-td>
                <vs-td :data="data[indextr].current_balance">
                  <vs-button
                    v-if="switch3"
                    color="danger"
                    @click="unsetpostpaid(data[indextr].user_id)"
                    type="gradient"
                    size="small"
                    >!Delete</vs-button
                  >
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-col>
      </vs-row>
      <vue-json-pretty :data="selectedUser"> </vue-json-pretty>
    </vx-card>
  </div>
</template>
<script>
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
export default {
  components: {
    VueJsonPretty,
  },
  data() {
    return {
      search: "",
      postpaidinfo: [],
      selectedUser: {},
      switch3: false,
    };
  },
  methods: {
    getpostpaidlist() {
      // console.log(this.postpaiddata);
      this.$vs.loading();
      this.$http
        .get("/admin/billing/postpaid/list")
        .then((result) => {
          this.$vs.loading.close();
          // console.log(result.data.params.data);
          this.postpaidinfo = result.data.params.data;
          // console.log(this.postpaidinfo);
          //   this.$vs.notify({ text: result.data.message, color: "success" });
        })
        .catch((err) => {
          this.$vs.loading.close();
          console.log(err);
          //   this.$vs.notify({ text: err.response.data.message, color: "danger" });
        });
    },
    doubleSelection() {
      //   console.log("pedarm");
      //   console.log(this.selectedUser.id);
      this.$router.push(`/user?id=${this.selectedUser.user_id}`);
    },
    searchpostpaiduser() {
      this.$http
        .get(`/admin/billing/postpaid/list?search=${this.search}`)
        .then((result) => {
          // console.log(result);
          this.postpaidinfo = result.data.params.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    unsetpostpaid(data) {
      //   console.log(data);
      // console.log(this.postpaiddata);
      this.$http
        .post("/admin/billing/postpaid/delete", {
          user_id: data,
        })
        .then((result) => {
          // console.log(result);
          this.$vs.notify({ text: result.data.message, color: "success" });
        })
        .catch((err) => {
          // console.log(err);
          this.$vs.notify({ text: err.response.data.message, color: "danger" });
        })
        .finally(() => {
          this.getpostpaidlist();
        });
    },
  },
  created() {
    this.getpostpaidlist();
  },
};
</script>
